'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultilangStringModelFactory = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _nestedtypes = require('nestedtypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MultilangStringModelFactory = exports.MultilangStringModelFactory = function MultilangStringModelFactory(languages) {
    /** make object with keys from languages array and values returned by cb*/
    var fillBy = function fillBy(cb) {
        return languages.reduce(function (result, lang) {
            return Object.assign(result, _defineProperty({}, lang, cb(lang)));
        }, {});
    };

    var model = _nestedtypes.Model.extend({
        defaults: fillBy(function () {
            return String.value(null);
        }),

        constructor: function constructor(value) {
            var parsed = void 0;
            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
                parsed = value; // value like {en: 'text'} (object)
            } else {
                try {
                    parsed = JSON.parse(value); // value is like '{"en": "text", "ru": "text"}' (string)
                } catch (e) {
                    parsed = fillBy(function () {
                        return value;
                    }); // value is like 'text' (string)
                }
            }
            _nestedtypes.Model.call(this, Object.assign(fillBy(function () {
                return '';
            }), parsed));
        },
        toJSON: function toJSON() {
            var _this = this;

            return JSON.stringify(JSON.stringify(fillBy(function (lang) {
                return _this[lang];
            })));
        },


        get suppressTypeErrors() {
            return true;
        },

        get isMultilang() {
            return true;
        }
    });

    if (!model.has.checkEvery) {
        model.has.constructor.prototype.checkEvery = function checkEvery(validator, message) {
            return languages.reduce(function (self, language) {
                var extendedMessage = Object.assign({ language: language }, (typeof message === 'undefined' ? 'undefined' : _typeof(message)) === 'object' && message !== null ? message : { message: message });

                return self.check(function (value) {
                    return validator(value ? value[language] : null);
                }, extendedMessage);
            }, this);
        };
    }

    return model;
};


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas-common-models/dist/MultilangStringModelFactory.js
// module id = 1404
// module chunks = 118